import React from 'react';

import useWindowSize from 'hooks/useWindowSize';

import { colors } from 'style/theme';

import { Svg, Waves, Header } from './styled';

const Wave = () => {
  const { width } = useWindowSize();

  return (
    <Waves>
      <Svg>
        <path
          d={`M0,
            120 C200,
            200 600,
            0 ${width},
            100 L${width},
            00 L0,
            0 Z
          `}
          style={{ stroke: 'none', fill: colors.turquoise }}
        />
      </Svg>
      <Header>Our partners</Header>
    </Waves>
  );
};

export default Wave;
